import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, removeSiteAction } from '../../reducers/actions';
import { SiteService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.DELETE_SITE),
    switchMap(action =>
      SiteService.delete(action.siteId, store).pipe(
        map(() => removeSiteAction(action.siteId)),
        catchError(retryAuthentication(action$, 'epics/sites/deleteSite'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/sites/deleteSite.js